import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M213.333333,960 C213.333333,792.64 269.333333,638.293333 362.773333,513.6 L1406.4,1557.22667 C1281.70667,1650.66667 1127.36,1706.66667 960,1706.66667 C548.373333,1706.66667 213.333333,1371.62667 213.333333,960 M1706.66667,960 C1706.66667,1127.36 1650.66667,1281.70667 1557.22667,1406.4 L513.6,362.773333 C638.293333,269.333333 792.64,213.333333 960,213.333333 C1371.62667,213.333333 1706.66667,548.373333 1706.66667,960 M960,0 C429.76,0 0,429.76 0,960 C0,1490.24 429.76,1920 960,1920 C1490.24,1920 1920,1490.24 1920,960 C1920,429.76 1490.24,0 960,0",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconNoSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconNoSolid, _Component);

  var _super = _createSuper(IconNoSolid);

  function IconNoSolid() {
    _classCallCheck(this, IconNoSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconNoSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconNo",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconNoSolid.displayName = "IconNoSolid";
  return IconNoSolid;
}(Component);

IconNoSolid.glyphName = 'no';
IconNoSolid.variant = 'Solid';
IconNoSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconNoSolid;
export { IconNoSolid };